import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core'
import { ProductsService } from '@cms/services/products.service'
import { SettingService } from '@cms/services/setting.service'
import { UtilService } from '@cms/services/util.service'
import { cloneDeep } from 'lodash'
import { NzMessageService } from 'ng-zorro-antd'

export interface Properties2 {
  id: any
  property_info: string
  children: Children[]
}

export interface Children {
  checked?: boolean
  id: number
  product_sort: any
  rating: any
  review_count: any
  buy_limit: number
  cate_id: number
  barcode: any
  barcode_format?: string
  group: any
  prop_enable: number
  title_lang1: string
  title_lang2: string
  title_lang3: string
  title_lang4: string
  status: number
  hilight?: number
  permalink: any
  permalink_lang1: string
  permalink_lang2: string
  permalink_lang3: string
  permalink_lang4: string
  feature_img: string
  feature_img_font: any
  image_gallery?: any[]
  short_desc_lang1: string
  short_desc_lang2: string
  short_desc_lang3: string
  short_desc_lang4: string
  product_desc_lang1: any
  product_desc_lang2: any
  product_desc_lang3: any
  product_desc_lang4: any
  dynamic: any
  weight: number
  price4?: number
  price3?: number
  price2?: number
  price1?: number
  price: number
  temp_price?: number
  cost_price: number
  unit: any
  unit_ratio: number
  max: any
  mix: any
  instock: number
  picture1: any
  picture2: any
  picture3: any
  options: string
  created_date: string
  updated_date: string
  created_by: string
  updated_by: string
  sku: string
  size_width: number
  size_length: number
  size_height: number
  property_info: string
  properties_desc: string
  properties_sort: number
  properties_desc2: string
  property_info2: string
  properties_sort2: number
  group_id: string
  uuid: any
  properties_main: number
  seo_title_lang1?: string
  seo_title_lang2?: string
  seo_title_lang3?: string
  seo_title_lang4?: string
  activity_by: string
  activity_uuid?: string
  activity_type: string
  transaction_ref: any
  short_desc2_lang1: any
  short_desc2_lang2: any
  short_desc2_lang3: any
  short_desc2_lang4: any
  property_info_table_status: number
  property_info2_table_status: number
  property_info_table: any
  property_info2_table: any
  property_info_table_desc: any
  property_info2_table_desc: any
  points: number
  status_redemption: number
  tmp_points: number
  product_type: string
  vat_rate: number
  vat_option: string
  pre_order: number
  related_product_setting: string
  display: string
  company_id: any
  brand_id: any
  location_zone: any
  location_shelf: any
  location_level: any
}

@Component({
  selector: 'ket-modal-edit-products-properties',
  templateUrl: './modal-edit-products-properties.component.html',
  styleUrls: ['./modal-edit-products-properties.component.scss'],
})
export class KetModalEditProductsPropertiesComponent implements OnInit {
  @Input() selectedLang = 'lang1'

  @Input() froalaOption = ''
  @Input() feature_option = {
    BRAND: false,
    COMPANY: false,
  }
  @Input() company = []
  @Input() brands = []

  @Output() onSelect: EventEmitter<boolean> = new EventEmitter(false)
  @Output() onClose: EventEmitter<boolean> = new EventEmitter(false)

  constructor(
    private Service_Product: ProductsService,
    private Service_Setting: SettingService,
    private Service_Util: UtilService,
    private message: NzMessageService,
  ) {}

  use_all_properties = {
    product_name: true,
    short_desc: true,
    feature_img: true,
    image_gallery: true,
    section_element: true,
    normal_price: true,
    discount_price: true,
    category: true,
    weight: true,
    size_box: true,
    company: true,
    brand: true,
  }
  model: any = {
    cate_id: 0,
    normal_price: 0,
    discount_price: 0,
    weight: 0,
    size_width: 0,
    size_length: 0,
    size_height: 0,
    feature_img: '',
    image_gallery: [],
    sku: '',
    prop_enable: 0,
    properties_desc: '',
    properties_desc2: '',
    property_info: '',
    property_info2: '',
    temp_price: 0,
    price: 0,
    title_lang1: '',
    title_lang2: '',
    title_lang3: '',
    title_lang4: '',
    company_id: '',
    brand_id: '',
  }
  products2: (Properties2 & { properties: Children; is_selected: boolean })[] = []
  products: (Children & { is_selected: boolean })[] = []
  product_select = false
  allcategory: any = []
  product_img_class = ''
  product_main: Properties2 & { properties: Children; is_selected: boolean } = null
  noimg: any
  lang: any = []
  prop_enable = 1

  defulat_name = {
    title_lang1: '',
    title_lang2: '',
    title_lang3: '',
    title_lang4: '',
  }

  async ngOnInit() {
    this.allcategory = await this.Service_Product.productMainCategory()
    this.lang = await this.Service_Util.getLangs()
    const pop_key = ['default_no_image', 'product_img_class']
    const option: any = await this.Service_Setting.searchOption({ pop_key: pop_key }).catch((err) => {
      console.error(err)
      return []
    })

    const _option: any = {}
    option.forEach((obj) => {
      _option[obj.pop_key] = obj.pop_value
      //console.log(_option)
    })
    this.noimg = _option.default_no_image
    this.product_img_class = _option.product_img_class
  }

  editProduct(product: any, product_main: any) {
    this.product_select = true
    this.model = product
    this.defulat_name = {
      title_lang1: cloneDeep(product.title_lang1) || '',
      title_lang2: cloneDeep(product.title_lang2) || '',
      title_lang3: cloneDeep(product.title_lang3) || '',
      title_lang4: cloneDeep(product.title_lang4) || '',
    }
    if (this.prop_enable == 2) {
      this.product_main = cloneDeep(product_main)
      ;(this.product_main.children = this.product_main.children.map((p) => {
        return { ...p, checked: false }
      })),
        (this.model.discount_price = 0)
      this.model.normal_price = 0
      this.model.image_gallery = this.model.image_gallery || []

      if (!Array.isArray(this.model.image_gallery)) {
        this.model.image_gallery = []
      }

      if (this.model.temp_price) {
        this.model.normal_price = this.model.temp_price
        this.model.discount_price = this.model.price
      } else {
        this.model.normal_price = this.model.price
      }
    }
    this.onSelect.emit(true)
    console.log(this.model, this.product_main)
  }

  addImageGallery() {
    if (!Array.isArray(this.model.image_gallery)) {
      this.model.image_gallery = []
    }
    this.model.image_gallery.push({ path: this.noimg, width: 200, height: 200 })
  }

  deleteImageGallery(i) {
    this.model.image_gallery.splice(i, 1)
  }

  async select_propertie() {
    this.product_main = cloneDeep(this.product_main)
    this.product_main.children = this.product_main.children.map((p) => {
      return { ...p, checked: false }
    })
  }

  async saveProduct() {
    if (this.prop_enable == 2) {
      this.model = {
        ...this.model,
        details: this.product_main.children
          .map((p) => {
            if (p.checked) {
              return p
            }
          })
          .filter((p) => p),
      }
    } else {
      this.model = {
        ...this.model,
        details: [],
      }
    }

    for (const lang of this.lang) {
      if (this.model['title_' + lang.ref] && this.model['title_' + lang.ref].length > 255) {
        alert(`โปรดระบุ  ชื่อสินค้า ภาษา ${lang.name}  ไม่เกิน 255 characters`)
      }

      if (!this.model['title_' + lang.ref]) {
        alert(`โปรดระบุ  ชื่อสินค้า ภาษา ${lang.name}  ไม่เกิน 255 characters`)
      }
    }

    this.model['use_all_properties'] = this.use_all_properties

    if (this.model.discount_price > 0 && this.model.discount_price != '') {
      this.model.price = this.model.discount_price
      this.model.temp_price = this.model.normal_price
    } else {
      this.model.price = this.model.normal_price
      this.model.temp_price = null
    }

    if (this.use_all_properties.normal_price) {
      this.model.details.forEach((obj) => {
        obj.normal_price = this.model.normal_price
      })
    }

    if (this.use_all_properties.discount_price) {
      this.model.details.forEach((obj) => {
        obj.discount_price = this.model.discount_price
      })
    }

    $('.theme-loader').fadeIn()
    // console.log(this.model.details.find(x=>x.sku =='OKZIZ-2413901'));
    // return ;
    this.Service_Product.updateProduct(this.model)
      .then(async (data) => {
        this.onClose.emit(true)
        $('.theme-loader').fadeOut()
        // this._drawerRef.close(true)
      })
      .catch((data) => {
        console.log(data.error.message)
        this.message.error(data.error.message, { nzDuration: 13000 })
      })
      .finally(() => {
        $('.theme-loader').fadeOut()
      })
  }

  on_product(propobj: any, prop_enable: number) {
    this.prop_enable = prop_enable
    if (prop_enable == 1) {
      this.products = cloneDeep(propobj.propertie_tmp)
    } else {
      this.products2 = cloneDeep(
        propobj.propertie_tmp2.map((product) => {
          const main = product.children.find((child) => child.properties_main)
          if (main) {
            return {
              ...product,
              is_selected: false,
              properties: main,
            }
          } else {
            return {
              ...product,
              is_selected: false,
              properties: product.children[0],
            }
          }
        }),
      )
    }
    console.log(this.model)
  }
}
